<template>
  <div v-if="showBanner" class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-6">
    <div class="max-w-md w-full bg-zinc-900 border border-zinc-800 rounded-2xl p-8 space-y-6 shadow-2xl">
      <!-- Icon -->
      <div class="w-16 h-16 mx-auto bg-gradient-to-br from-purple-950/40 to-pink-950/40 border border-purple-900/40 rounded-full flex items-center justify-center">
        <i class="fas fa-lock text-purple-400 text-2xl"></i>
      </div>

      <!-- Content -->
      <div class="text-center space-y-3">
        <h2 class="text-xl font-bold text-white">Fonctionnalité Équipe</h2>
        <p class="text-sm text-zinc-400 leading-relaxed">
          La gestion des employés et du staff est réservée aux plans <strong class="text-white">Équipe Lab</strong> et <strong class="text-white">Salon Plus Cloud</strong>.
        </p>
        <p class="text-xs text-zinc-500">
          Votre plan actuel : <span class="text-blue-400 font-semibold">Solo Studio</span>
        </p>
      </div>

      <!-- Features -->
      <div class="bg-zinc-950/60 border border-zinc-900 rounded-xl p-4 space-y-2">
        <p class="text-[10px] uppercase tracking-wider text-zinc-600 font-semibold">Avec Équipe Lab, débloquez :</p>
        <ul class="space-y-2 text-xs text-zinc-400">
          <li class="flex items-start gap-2">
            <i class="fas fa-check text-emerald-400 text-xs mt-0.5"></i>
            <span>Jusqu'à 3 comptes opérateurs</span>
          </li>
          <li class="flex items-start gap-2">
            <i class="fas fa-check text-emerald-400 text-xs mt-0.5"></i>
            <span>Gestion des horaires & congés</span>
          </li>
          <li class="flex items-start gap-2">
            <i class="fas fa-check text-emerald-400 text-xs mt-0.5"></i>
            <span>Planning multi-opérateurs</span>
          </li>
          <li class="flex items-start gap-2">
            <i class="fas fa-check text-emerald-400 text-xs mt-0.5"></i>
            <span>100 Crédits SMS / mois</span>
          </li>
        </ul>
      </div>

      <!-- Actions -->
      <div class="space-y-2">
        <RouterLink
          to="/subscription/plans"
          class="w-full flex items-center justify-center gap-2 px-5 py-3 bg-white hover:bg-[#D5CCBC] text-black rounded-xl text-sm font-bold uppercase tracking-wider transition-colors"
        >
          <i class="fas fa-star"></i>
          Voir les Plans
        </RouterLink>
        <button
          @click="goBack"
          class="w-full px-5 py-3 bg-zinc-800 hover:bg-zinc-700 text-zinc-300 rounded-xl text-xs font-semibold uppercase tracking-wider transition-colors"
        >
          Retour au Dashboard
        </button>
      </div>

      <!-- Close button -->
      <button
        @click="closeBanner"
        class="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-zinc-800 hover:bg-zinc-700 text-zinc-500 hover:text-white transition-colors"
      >
        <i class="fas fa-times text-sm"></i>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter, RouterLink } from 'vue-router'



const router = useRouter()
const showBanner = ref(false)

onMounted(() => {
  const accountType = localStorage.getItem('accountType')

  // Afficher le banner seulement si c'est un compte solo
  if (accountType === 'solo') {
    showBanner.value = true
  }
})

const closeBanner = () => {
  showBanner.value = false
  router.push('/')
}

const goBack = () => {
  router.push('/')
}
</script>
